<script lang="ts">
  import type { HTMLTextareaAttributes } from "svelte/elements";
  import { cn } from "$lib/utils/cn";
  import { fieldStateClass, fieldStateFocusRing, type FormFieldState } from "./fieldState";

  type Props = Omit<HTMLTextareaAttributes, "value"> & {
    class?: string;
    invalid?: boolean;
    state?: FormFieldState;
    value?: string;
  };

  let {
    class: className,
    invalid = false,
    state,
    value = $bindable(""),
    rows = 3,
    ...rest
  }: Props = $props();

  const visualState = $derived(state ?? (invalid ? "invalid" : "default"));
</script>

<textarea
  {rows}
  bind:value
  class={cn(
    "surface-input",
    "w-full rounded-md px-3 py-2 text-sm",
    "placeholder:text-(--surface-fg-subtle)",
    "transition-[border-color,box-shadow,background-color] duration-fast ease-standard",
    "focus:outline-none focus:ring-2",
    fieldStateFocusRing(visualState, invalid),
    fieldStateClass(visualState, { invalid }),
    "disabled:opacity-60 disabled:cursor-not-allowed",
    className,
  )}
  aria-invalid={visualState === "invalid" || invalid || undefined}
  {...rest}
></textarea>
